import Env from '/env';

function buildUrl(sessionId) {
    const base = String(Env.API_URL || '').replace(/\/+$/, '');
    return `${base}/api/ai-chat/sessions/${sessionId}/ask`;
}

function parseSseBlock(raw) {
    let eventName = null;
    const dataLines = [];
    raw.split('\n').forEach(line => {
        if (!line) return;
        if (line.startsWith(':')) return;
        const idx = line.indexOf(':');
        const field = idx === -1 ? line : line.slice(0, idx);
        const value = idx === -1 ? '' : line.slice(idx + 1).replace(/^ /, '');
        if (field === 'event') eventName = value;
        else if (field === 'data') dataLines.push(value);
    });
    if (!eventName) return null;
    const dataStr = dataLines.join('\n');
    let data = null;
    try {
        data = dataStr ? JSON.parse(dataStr) : null;
    } catch (e) {
        data = null;
    }
    return { event: eventName, data };
}

export function askAi({ sessionId, question, model, onEvent }) {
    const controller = new AbortController();
    const url = buildUrl(sessionId);
    const token = localStorage.getItem('token');

    const body = { question };
    if (model) body.model = model;

    const promise = (async () => {
        let response;
        try {
            response = await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    Accept: 'text/event-stream',
                },
                body: JSON.stringify(body),
                signal: controller.signal,
            });
        } catch (e) {
            if (e && e.name === 'AbortError') {
                onEvent({ event: 'aborted', data: {} });
                return;
            }
            onEvent({ event: 'error', data: { message: e && e.message ? e.message : 'Network error' } });
            onEvent({ event: 'done', data: {} });
            return;
        }

        if (!response.ok) {
            onEvent({ event: 'error', data: { message: `HTTP ${response.status}`, status: response.status } });
            onEvent({ event: 'done', data: {} });
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        try {
            let streamDone = false;
            while (!streamDone) {
                const chunk = await reader.read();
                if (chunk.done) {
                    streamDone = true;
                } else {
                    buffer += decoder.decode(chunk.value, { stream: true });
                    let idx = buffer.indexOf('\n\n');
                    while (idx !== -1) {
                        const block = buffer.slice(0, idx);
                        buffer = buffer.slice(idx + 2);
                        const parsed = parseSseBlock(block);
                        if (parsed) onEvent(parsed);
                        idx = buffer.indexOf('\n\n');
                    }
                }
            }
            buffer += decoder.decode();
            if (buffer.trim()) {
                const parsed = parseSseBlock(buffer);
                if (parsed) onEvent(parsed);
            }
        } catch (e) {
            if (e && e.name === 'AbortError') {
                onEvent({ event: 'aborted', data: {} });
                return;
            }
            onEvent({ event: 'error', data: { message: e && e.message ? e.message : 'Stream error' } });
            onEvent({ event: 'done', data: {} });
        }
    })();

    return {
        cancel: () => controller.abort(),
        promise,
    };
}
